import React from 'react';
import { Clock, ShieldCheck, Zap } from 'lucide-react';
import { Button } from './ui/Button';
import { AnimatedSection } from './ui/AnimatedSection';
export function FinalCTA() {
  return <AnimatedSection className="py-24 bg-brand-surface border-t border-brand-border relative overflow-hidden" data-id="element-72">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-brand-yellow/10 via-brand-dark to-brand-dark -z-10" data-id="element-73" />

      <div className="container mx-auto px-4 md:px-6" data-id="element-74">
        <div className="max-w-4xl mx-auto text-center" data-id="element-75">
          <div className="inline-flex items-center justify-center gap-2 text-brand-yellow font-bold text-xl mb-4" data-id="element-76">
            <Clock className="w-6 h-6 animate-pulse" data-id="element-77" />
            PRECIO DE LANZAMIENTO
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-12 text-white" data-id="element-78">
            El precio sube $10.000 ARS.{' '}
            <span className="text-brand-yellow" data-id="element-79">No vuelve.</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-80">
            {/* Standard */}
            <div className="bg-brand-dark border border-brand-border rounded-xl p-6 flex flex-col items-center" data-id="element-81">
              <div className="text-2xl mb-2" data-id="element-82">📘</div>
              <h3 className="text-xl font-bold text-white mb-4" data-id="element-83">MEGA PACK</h3>
              <div className="flex items-baseline gap-2 mb-6" data-id="element-84">
                <span className="text-zinc-500 line-through text-lg" data-id="element-85">
                  $45.000
                </span>
                <span className="text-3xl font-bold text-white" data-id="element-86">
                  $19.990{' '}
                  <span className="text-sm text-zinc-400 font-normal" data-id="element-87">ARS</span>
                </span>
              </div>
              <Button variant="outline" fullWidth onClick={() => window.open('https://www.soportesaberdigital.com/cart/48947971293423:1', '_blank')} data-id="element-88">
                → QUIERO MI MEGA PACK
              </Button>
            </div>

            {/* Pro */}
            <div className="bg-brand-dark border-2 border-brand-yellow rounded-xl p-6 flex flex-col items-center shadow-[0_0_20px_rgba(250,204,21,0.1)]" data-id="element-89">
              <div className="text-2xl mb-2" data-id="element-90">🏆</div>
              <h3 className="text-xl font-bold text-white mb-4 text-center" data-id="element-91">
                MEGA PACK + CONFIGURACIÓN PRO
              </h3>
              <div className="flex items-baseline gap-2 mb-6" data-id="element-92">
                <span className="text-zinc-500 line-through text-lg" data-id="element-93">
                  $65.000
                </span>
                <span className="text-3xl font-bold text-white" data-id="element-94">
                  $27.990{' '}
                  <span className="text-sm text-zinc-400 font-normal" data-id="element-95">ARS</span>
                </span>
              </div>
              <Button fullWidth className="animate-pulse-slow" onClick={() => window.open('https://www.soportesaberdigital.com/cart/48948441252079:1', '_blank')} data-id="element-96">
                → QUIERO EL COMBO COMPLETO
              </Button>
            </div>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-sm text-zinc-400 bg-brand-dark/50 p-4 rounded-lg border border-brand-border inline-flex" data-id="element-97">
            <div className="flex items-center gap-2" data-id="element-98">
              <ShieldCheck className="w-5 h-5 text-brand-yellow" data-id="element-99" />
              <span data-id="element-100">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-101">
              <Zap className="w-5 h-5 text-brand-yellow" data-id="element-102" />
              <span data-id="element-103">Acceso en 5 minutos</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-104">
              <span className="text-green-500 font-bold" data-id="element-105">✓</span>
              <span data-id="element-106">Garantía 7 días</span>
            </div>
          </div>

          <p className="text-xs text-zinc-500 mt-4" data-id="element-107">
            Tarjeta / Transferencia / Mercado Pago / PayPal
          </p>
        </div>
      </div>
    </AnimatedSection>;
}